import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
/* [...] */
import 'hammerjs';

import { AppModule } from './app/appp.module';
import { environment as environmentPromise} from './environments/environment';

environmentPromise.then(environment => {

  if (environment['production']) {
    enableProdMode();
  }
  platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));;
});

// if (environment.production) {
//   enableProdMode();
// }
//
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));
